import { view, i18next } from '@yola/ws-sdk';
import elementSettings from 'src/js/modules/element-settings';
import getGalleryItems from '../../../ws-gallery/helpers/get-gallery-items';
import controlIds from '../../constants/control-ids';
import appearanceAttributes from '../../constants/appearance-attributes';
import getCorners from './corners';

const {
  helpers: { getTargetElementIds },
} = elementSettings;

const getThisMediaAppearanceSettings = (elementId, settingId) => {
  const elementIds = getTargetElementIds(elementId);

  return {
    [controlIds.BORDER]: {
      settingId,
      id: controlIds.BORDER,
      title: i18next.t('Border'),
      targets: [appearanceAttributes.BORDER],
      elementIds,
    },
    [controlIds.SHADOW]: {
      settingId,
      id: controlIds.SHADOW,
      title: i18next.t('Shadow'),
      targets: [appearanceAttributes.SHADOW],
      elementIds,
    },
    [controlIds.CORNERS]: getCorners(settingId, { elementIds }),
    [controlIds.CORNERS_SECTION]: {
      settingId,
      id: controlIds.CORNERS_SECTION,
      title: i18next.t('Corners'),
      elementIds,
      targets: getCorners(settingId, { elementIds }).targets,
      computeFallbackValue: getCorners(settingId, { elementIds }).computeFallbackValue,
    },
  };
};

const getAllMediaAppearanceSettings = (elementId, settingId) => {
  const galleryItems = getGalleryItems(elementId);
  const elementIds = galleryItems.map((el) => view.accessors.getLiveElementId(el));

  return {
    [controlIds.BORDER]: {
      settingId,
      id: controlIds.BORDER,
      title: i18next.t('Border'),
      targets: [appearanceAttributes.BORDER],
      elementIds,
    },
    [controlIds.SHADOW]: {
      settingId,
      id: controlIds.SHADOW,
      title: i18next.t('Shadow'),
      targets: [appearanceAttributes.SHADOW],
      elementIds,
    },
    [controlIds.CORNERS]: getCorners(settingId, { elementIds }),
    [controlIds.CORNERS_SECTION]: {
      settingId,
      id: controlIds.CORNERS_SECTION,
      title: i18next.t('Corners'),
      elementIds,
      targets: getCorners(settingId, { elementIds }).targets,
      computeFallbackValue: getCorners(settingId, { elementIds }).computeFallbackValue,
    },
  };
};

export { getThisMediaAppearanceSettings, getAllMediaAppearanceSettings };
